<template>
  <Modal v-model="show" :mask-closable="false"  :loading="loading">
      <div slot="header" class="modal-header">修改价格</div>
      <Form :model="formData" :label-width="85" :rules="formRules" ref="formValidate">
        <FormItem label="租金价格" prop="price">
          <Input v-model="formData.price"  class="item-width" :number="true"></Input>
        </FormItem>
      </Form>

      <div slot="footer">
        <Button type="text" size="large" @click="handleCancel">取消</Button>
        <Button type="primary" size="large" @click="save" :loading="loading">
          <span v-if="!loading">保存</span>
          <span v-else>保存中...</span>
        </Button>
      </div>
    </Modal>
  
</template>
 
<script type="text/ecmascript-6">
export default {
   props: {
    n: {
      type: Number,
      default: 0
    }
  },
  watch: {
		n() {
      this.$refs['formValidate'].resetFields();
			this.loading = false
      this.show = true;
		}
	},
  data () {
    const validatePrice = (rule, value, callback) => {
  
			if(value===''){
				callback(new Error('租金价格不能为空'));
			}
			if(typeof value === 'string'){
				callback(new Error('请输入正确的金额'));
			}
			if(value <= 0){
				callback(new Error('金额应大于0'));
			}else{
				callback();
			}
		}
    return {
      show:false,
      loading:false,
      formData: {
        price:''
      },
      formRules:{
				price:[
					{ required: true, validator: validatePrice, trigger: 'blur', type:'number'}
				]
			},
    
    };
  },
  methods:{
    handleCancel(){
      this.show = false
    },
    save() {
      let data = null
      this.$refs["formValidate"].validate(bool => {
        if (bool) {  
          data = this.formData;
          console.log('保存修改')
          this.show = false;
        } 
      });
    }
  }
  
}
</script>
 
<style lang="css" scoped>
.item-width{
    width: 260px;
}
 
</style>